import { DatePicker, DateTimePicker } from '@all-manager/design-system-v2';
import { startOfDay } from 'date-fns';
import { Controller, FieldPath, FieldValues, UseFormReturn } from "react-hook-form";

type Props<TFieldValues extends FieldValues, TTransformedValues extends FieldValues> = {
  form: UseFormReturn<TFieldValues, unknown, TTransformedValues>;
  name: FieldPath<TFieldValues>;
  label: string;
  required?: boolean;
  isTimeManaged?: boolean;
  onChange?: (date: Date) => void;
  fullWidth?: boolean;
}

export default function DateField<TFieldValues extends FieldValues, TTransformedValues extends FieldValues>(props: Props<TFieldValues, TTransformedValues>) {
  return (
    <Controller
      control={props.form.control}
      name={props.name}
      render={({ field, fieldState }) => {
        function handleChange(date: Date | null) {
          if (!date || Number.isNaN(date.getTime())) {
            return;
          }
          const normalized = props.isTimeManaged ? date : startOfDay(date);
          props.onChange?.(normalized);
          field.onChange(normalized);
        }

        const pickerProps = {
          label: props.label,
          value: field.value ?? null,
          onChange: handleChange,
          inputRef: field.ref,
          required: props.required,
          fullWidth: props.fullWidth,
          error: !!fieldState.error,
          helperText: fieldState.error?.message,
        };

        return (
          <>
            {props.isTimeManaged ? <DateTimePicker {...pickerProps} /> : <DatePicker {...pickerProps} />}
          </>
        );
      }}
    />
  );
}
